import { getYoutubeVideoId } from "src/media/Youtube";

function getEmbedUrl(url: string): string | null {
  try {
    const parsed = new URL(url);

    if (
      parsed.hostname.includes("youtube.com") ||
      parsed.hostname.includes("youtu.be")
    ) {
      const videoId = getYoutubeVideoId(url);

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    if (parsed.hostname.includes("vimeo.com")) {
      const match = parsed.pathname.match(/\/(\d+)/);

      if (match) {
        return `https://player.vimeo.com/video/${match[1]}`;
      }
    }
  } catch {
    return null;
  }

  return null;
}

interface VideoUrlPreviewProps {
  url: string;
}

export function VideoUrlPreview(props: VideoUrlPreviewProps) {
  const embedUrl = getEmbedUrl(props.url);

  if (!embedUrl) {
    return (
      <a
        href={props.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-blue-500 hover:underline truncate block"
      >
        {props.url}
      </a>
    );
  }

  return (
    <div className="rounded-lg overflow-hidden border border-slate-200 aspect-video">
      <iframe
        src={embedUrl}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
